import React from 'react';
import { ChevronsExpandUpRight } from '@gravity-ui/icons';
import { Button, Icon } from '@gravity-ui/uikit';
import { useMonaco } from '../../../../core/components/Form/hooks';
import { block } from '../../../utils';
import { MonacoHeader } from './MonacoHeader';
import { MonacoInputDialog } from './MonacoInputDialog';
import { useMonacoOptions } from './useMonacoOptions';
import './MonacoInputBase.css';
const b = block('monaco-input');
export const MonacoInputBase = ({ name, input, spec, MonacoComponent, withoutDialog, }) => {
    const { value, onChange } = input;
    const MonacoEditor = useMonaco() || MonacoComponent;
    const { monacoParams, disabled, layoutTitle } = spec.viewSpec;
    const { language, fontSize } = monacoParams !== null && monacoParams !== void 0 ? monacoParams : { language: 'plaintext', fontSize: 11 };
    const [monacoEditorDialog, setMonacoEditorDialog] = React.useState(false);
    const [monacoValue, setMonacoValue] = React.useState(value);
    const handleMonacoEditorDialogClose = React.useCallback(() => setMonacoEditorDialog(false), []);
    const dialogButton = React.useMemo(() => {
        if (!withoutDialog) {
            return (React.createElement(Button, { onClick: () => setMonacoEditorDialog(true), qa: `${name}-open-dialog` },
                React.createElement(Icon, { data: ChevronsExpandUpRight, size: 16 })));
        }
        return;
    }, [withoutDialog, setMonacoEditorDialog, name]);
    React.useEffect(() => onChange(monacoValue), [monacoValue]);
    const options = useMonacoOptions(fontSize, disabled !== null && disabled !== void 0 ? disabled : false);
    if (!MonacoEditor) {
        return null;
    }
    return (React.createElement("div", { className: b() },
        React.createElement("div", { className: b('container'), "data-qa": name },
            React.createElement(MonacoHeader, { language: language, editButton: dialogButton }),
            React.createElement(MonacoEditor, { language: language, value: monacoValue, height: "300", onChange: setMonacoValue, options: options })),
        React.createElement(MonacoInputDialog, { name: name, title: layoutTitle, fontSize: fontSize, value: monacoValue, visible: monacoEditorDialog, language: language, changeMonacoValue: setMonacoValue, onChange: onChange, onClose: handleMonacoEditorDialogClose, MonacoComponent: MonacoComponent })));
};
export const MonacoInput = (props) => (React.createElement(MonacoInputBase, Object.assign({}, props)));
